// extracted by mini-css-extract-plugin
module.exports = {"color":"s_color__2vTXz"};